import React from 'react';

//Componets
import TextField from '@mui/material/TextField';
import { ExtendedFormik, Form } from '../extended-formik';
import { Button, Select, MenuItem } from '@mui/material';

//Hook & lib
import { useAxios } from '../../hooks/use-axios';
import * as Yup from 'yup';
import { eventUrl } from '../../constants/';

//css
import styled from 'styled-components';

const Root = styled.div`
  margin-top: 2%;
`;

const Label = styled.label`
  display: flex;
  flex: wrap;
  margin-bottom: 1%;
  font-size: 16px;
  font-weight: 600;
`;

const Row = styled.div`
  margin-top: 1%;
`;

const Error = styled.div`
  display: flex;
  flex: wrap;
  margin-bottom: 1%;
  font-size: 16px;
  color: red;
`;

export const CreateEventForm = props => {
  const { handleClose } = props;
  const { post } = useAxios();

  return (
    <Root>
      <ExtendedFormik
        initialValues={{
          name: '',
          event_type: '',
          camp: '',
          leadJudge: '',
          status: true,
        }}
        validationSchema={Yup.object({
          name: Yup.string()
            .max(1000, 'Debe tener un maximo de 30 caracteres')
            .min(3, 'Debe ser almenos 4 caracteres')
            .required('Required'),
        })}
        onSubmit={async (values, helpers) => {
          const data = {
            name: values.name,
            event_type: values.director,
            subdirector: values.subdirector,
            status: values.status,
          };
          const res = await post(eventUrl.CREATE_EVENT, data);
          // console.log(res);
          if (res) handleClose();
        }}
      >
        {formikProps => {
          const {
            values,
            errors,
            // status,
            handleChange,
            // handleBlur,
            // isSubmmitting,
          } = formikProps;

          return (
            <Form>
              <Row>
                <Label>Nombre</Label>
                <TextField required id='name' label='Required' value={values.name} onChange={handleChange} />
                {errors.name ? <Error>{errors.name}</Error> : null}
              </Row>
              <Row>
                <Label>Tipo Evento</Label>
                <TextField
                  required
                  id='event_type'
                  label='Required'
                  value={values.event_type}
                  onChange={handleChange}
                />
                {errors.event_type ? <Error>{errors.event_type}</Error> : null}
              </Row>
              <Row>
                <Label>Campamento</Label>
                <TextField required id='camp' label='Required' value={values.camp} onChange={handleChange} />
                {errors.camp ? <Error>{errors.camp}</Error> : null}
              </Row>
              <Row>
                <Label>Juez Encargado</Label>
                <TextField required id='leadJudge' label='Required' value={values.leadJudge} onChange={handleChange} />
                {errors.leadJudge ? <Error>{errors.leadJudge}</Error> : null}
              </Row>
              <Row>
                <Label>Status</Label>
                <Select
                  required
                  id='status'
                  name='status'
                  label='Required'
                  value={values.status}
                  onChange={handleChange}
                >
                  <MenuItem value={true}>Activo</MenuItem>
                  <MenuItem value={false}>Inactivo</MenuItem>
                </Select>
                {errors.status ? <Error>{errors.status}</Error> : null}
              </Row>
              <Row>
                <Button type='submit'>Guardar</Button>
              </Row>
            </Form>
          );
        }}
      </ExtendedFormik>
    </Root>
  );
};
